export function isNaNAndInfinity (value: number): number {
    if (Number.isNaN(value) || !Number.isFinite(value)) {
        return 0;
    }
    return value;
}
